// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","copyright":"footer-module--copyright--4FyNV","links":"footer-module--links--2iHdD"};